import React, { Component } from 'react' 
import { connect } from 'react-redux'
import { Route, Switch, Redirect } from 'react-router-dom'
import Modal from 'react-modal'

import { getImageUrl, getSelected, getMaxPaintFillColors, getAllPaintColors } from 'state/customize/selectors'
import { getPaintSummaryVM, getReplacementPaintfillVM, getPriceVM } from 'state/viewModels'
import * as actions from 'ducks/modules/customize'

import AppNav from './AppNav'
import CustomizeNav from 'components/CustomizeNav'
import InstanceView from 'components/InstanceView'
import PaintColorSwapModal from 'components/PaintColorSwapModal'
import { Button } from 'components/Buttons'

import FinishForm from './forms/FinishForm'
import PackageForm from './forms/PackageForm'
import FaceForm from './forms/FaceForm'
import BackForm from './forms/BackForm'
import TopForm from './forms/TopForm'
import SpecsForm from './forms/SpecsForm'
import AccessoriesForm from './forms/AccessoriesForm'
import AccessoriesView from 'components/AccessoriesView'
import AuthenticationForm from './forms/AuthenticationForm'
import AuthenticationView from 'components/AuthenticationView'
import ConfirmForm from './forms/ConfirmForm' 
import ConfirmView from 'components/ConfirmView' 

export class Customize extends Component {
  
  constructor() {
    super()
    this.state = { 
      ready: null,
      redirectToConfirm: false,
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    // this.props.onSelectAccessoryType( { field: "buyAPutter", id: id})
    //scroll to top between tabs -> https://reacttraining.com/react-router/web/guides/scroll-restoration
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  componentWillMount() {
    /* 18759: Invalid options rollback
    this.setState({ready: false, showInvalidOptionsRemoved: false, });
    */
    this.setState({ready: false});
    if (this.props.autoAuthenticate) {
      this.props.loadAuthenticatedPutter(this.props.putterId).then(() => {
        this.setState({ redirectToConfirm: true });
      });
    } else {
      this.props.loadPutter(this.props.putterId, this.props.buyAPutter);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      ready: !nextProps.loading,
      /* 18759: Invalid options rollback
      showInvalidOptionsRemovedWarning: nextProps.showInvalidOptionsRemovedWarning,
      */
    });
  }

  render() {
    if(!this.state.ready) return <div>Loading...</div>;
    if(this.props.autoAuthenticate && this.state.redirectToConfirm) {
      return <Redirect to={"/customize/" + this.props.putterId + "/confirm"} />;
    }
    
    return (
      <div> 
        <div className="customize-header">
          <div className="putter-header hidden-xs hidden-sm">{this.props.putterLabel}</div>
          <AppNav autoAddToSaved={this.props.autoAddToSaved} />
        </div>
        <CustomizeNav putterId={this.props.putterId} 
          page={this.props.location.pathname.substring(this.props.location.pathname.lastIndexOf('/')+1)} 
          confirmLink={this.props.price.buyLink}/>
        <div className="customize-header hidden-md hidden-lg">
          <div className="putter-header">{this.props.putterLabel}</div>
        </div>
        <div className={"customize-content " + (this.props.location.pathname.indexOf('auth') > 0 ? 'auth' : '')}>
          <div className="customize-forms">
            <div className="customize-form">
              <Switch>
              <Route exact path="/customize/:id/">
                <Redirect to={"/customize/" + this.props.putterId + "/finish"} />
              </Route>
              <Route exact path="/customize/:id/buy">
                <Redirect to={"/customize/" + this.props.putterId + "/finish"} />
              </Route>
              <Route path='/customize/:id/finish' component={FinishForm} />
              <Route path='/customize/:id/face' component={FaceForm} />
              <Route path='/customize/:id/back' component={BackForm} />
              <Route path='/customize/:id/top' component={TopForm} />
              <Route path='/customize/:id/specs' component={SpecsForm} />
              <Route path='/customize/:id/acc' 
                render={() => 
                  <div>
                    <AccessoriesForm setAccessoryType={this.props.onSelectAccessoryType}/>
                  </div>
              }/>
              <Route path='/customize/:id/auth' component={AuthenticationForm} />
              <Route path='/customize/:id/confirm' component={ConfirmForm} />
              </Switch>
            </div>
            <div>
              <Route path='/customize/:id/finish' component={PackageForm} />
            </div>
          </div>
          
          <div className="customize-view">
            <Switch>
              <Route path='/customize/:id/acc' 
                render={() => 
                  <div className={"accessories-view-container " + this.props.selectedAccessoryType}>
                    <AccessoriesView accessoryType={this.props.selectedAccessoryType}/>
                  </div>
              }/>
              <Route path='/customize/:id/auth' 
                render={() => 
                  <div className={"product-view-container"}>
                    <AuthenticationView />
                  </div>
              }/>
              <Route path='/customize/:id/confirm' 
                render={() => 
                  <div className="product-view-container">
                    <ConfirmView 
                      views={this.props.views} 
                      putterLabel={this.props.putterLabel}
                    />
                  </div>
              }/>
              <Route 
                render={() =>
                  <div className="product-view-container">
                    <InstanceView views={this.props.views}
                      selected={this.props.selectedView}
                      onSelectView={this.props.onSelectView}
                      isViewZoomIn={this.props.isViewZoomIn}
                      toggleViewZoom={this.props.toggleViewZoom}
                    />
                  </div>
                }/>
            </Switch>
          </div>
          
        </div>
        <PaintColorSwapModal 
          headerTitle="Color Limit"
          headerText="You have exceeded the maximum number of paintfill colors. Select the color that you would like to replace OR click cancel to cancel the selection."
          colorSelectedText="New Color"
          colorToSelectText="Select a color to replace:"
          replacementPaintFill={this.props.replacementPaintFill}
          paintSummary={this.props.paintSummary}
          maxPaintfillColors={this.props.maxPaintfillColors}
          replacePaint={this.props.replacePaint}
          cancel={this.props.cancelReplacementPaintFill}
        />
        
        <Modal className="customizer modal-popup" overlayClassName="modal-overlay"
          isOpen={typeof this.props.paintsValid !== 'undefined' && this.props.paintsValid !== null && !this.props.paintsValid}
          contentLabel="Invalid colors warning"
        > 
          <div>
            <div className="close-modal" onClick={() => this.props.applyFinish(false)}>X</div>
            <div className="min-price-modal-header">Invalid Colors Warning</div>
            <div className="min-price-modal-content">Some current colors are not valid for the chosen "Finish". If you choose to "CONTINUE" areas with invalid colors will be de-selected.</div>
            <div className="color-replace-buttons apply-finish-buttons">
              <Button onClick={() => this.props.applyFinish(false)}>CANCEL</Button>
              <Button onClick={() => this.props.applyFinish(true)}>CONTINUE</Button>
            </div>
          </div>
        </Modal>
        {/* 18759: Invalid options rollback
        <Modal className="customizer modal-popup" overlayClassName="modal-overlay"
          isOpen={this.state.showInvalidOptionsRemovedWarning}
          contentLabel="Invalid options removed warning"
        > 
          <div>
            <div className="close-modal" onClick={() => this.props.toggleShowInvalidOptionsRemovedWarning()}>X</div>
            <div className="min-price-modal-header">Invalid Options Removed Warning</div>
            <div className="min-price-modal-content">Some selected options are no longer available and have been removed.</div>
            <div className="color-replace-buttons apply-finish-buttons">
              <Button onClick={() => this.props.toggleShowInvalidOptionsRemovedWarning()}>OK</Button>
            </div>
          </div>
        </Modal>
        */
        }
        
      </div>
    );
  }
}

Customize.defaultProps = {
  putterLabel:'',
  autoAddToSaved:false,
  autoAuthenticate:false,
  buyAPutter:false, // Auto select the buy a putter accessory when loading
  views: []
};

const mapStateToProps = (state, ownProps) => {
  var putterValid = state.customize.instance.label === "" ||
    getSelected(state.customize, 'model') === state.customize.putter.id.toString();

  return { 
    putterValid : putterValid,
    putterId: ownProps.match.params.id ? ownProps.match.params.id : getSelected(state.customize, 'model'),
    maxPaintfillColors: putterValid ? getMaxPaintFillColors(state.customize) : 0,
    allPaintColors: putterValid ? getAllPaintColors(state.customize) : [],
    putterLabel: putterValid ? getSelected(state.customize , "label") : "",
    price: putterValid ? getPriceVM(state.customize) : 0,
    paintSummary: putterValid ? getPaintSummaryVM(state.customize) : [],
    replacementPaintFill: getReplacementPaintfillVM(state.customize),
    selectedView : state.customize.selectedView,
    paintSwapValid : state.customize.paintSwapValid,
    paintsValid : state.customize.paintsValid,
    isViewZoomIn : state.customize.isViewZoomIn,
    selectedAccessoryType : state.customize.selectedAccessoryType,
    loading : state.customize.loading,
    //18759: Invalid options rollback
    //showInvalidOptionsRemovedWarning : state.customize.showInvalidOptionsRemovedWarning ? state.customize.showInvalidOptionsRemovedWarning : false,
    views: [
      { name: 'FS', src: getImageUrl(state.customize, 'FS') },
      { name: 'BC', src: getImageUrl(state.customize, 'BC') },
      { name: 'PP', src: getImageUrl(state.customize, 'PP') }
    ]
  }
}

const mapDispatchToProps = {
  loadPutter: actions.loadPutter,
  loadAuthenticatedPutter: actions.loadAuthenticatedPutter,
  cancelReplacementPaintFill: actions.cancelReplacementPaintFill,
  replacePaint: actions.replacePaint,
  applyFinish: actions.applyFinish,
  onSelectView: actions.selectView,
  toggleViewZoom: actions.toggleViewZoom,
  onSelectAccessoryType: actions.selectAccessoryType,
  //18759: Invalid options rollback
  //toggleShowInvalidOptionsRemovedWarning: actions.toggleShowInvalidOptionsRemovedWarning,
}

export default connect(mapStateToProps, mapDispatchToProps)(Customize); 
